module.exports = __webpack_public_path__ + "static/comingSoon-d8e43846e3d376128f6316af110079b8.png";